import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BaseComponent } from '../../../base/base.component';
import { PageHeaderComponent } from '../../../core/labels/page-header.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';
import { Appeals } from '../../../../models/api/view/claim/details/appeals/appeals';
import { getClaimKey } from '../../../../functions/get-claim-key';

@Component({
  selector: 'app-appeals',
  imports: [
    DetailPanelComponent,
    DetailItemComponent,
    TableComponent,
    ColumnComponent,
    RouterModule,
    PageHeaderComponent,
  ],
  template: `
    <app-page-header label="Appeals" />
    <app-table
      [dataSource]="appealsLst"
      [pageSize]="5"
      [scrollable]="false"
      [expandable]="true"
      dataKey="id"
      recordLabel="Appeal"
    >
      <app-column name="receivedDate" label="Received" format="d" />
      <app-column name="decisionDue" label="Decision Due" format="d" />
      <app-column name="decisionMade" label="Decision Made" format="d" />
      <app-column name="decision" label="Decision" />
      <app-column name="reason" label="Reason" />

      <ng-template #expand let-data>
        <div class="tw-flex tw-gap-8">
          <div class="tw-basis-1/3">
            <app-detail-panel [dataSource]="data">
              <app-detail-item
                label="Date Appeal Received"
                name="receivedDate"
                format="d"
              />
              <app-detail-item
                label="Appeal Examiner"
                name="appealExaminer"
                format="d"
              />
              <app-detail-item
                label="Appeal Received by Examiner"
                name="receivedByExaminer"
                format="d"
              />
              <app-detail-item
                label="Begin Toll Date #1"
                name="beginTollDate1"
                format="d"
              />
              <app-detail-item
                label="Begin Toll Date #2"
                name="beginTollDate2"
                format="d"
              />
              <app-detail-item
                label="Begin Toll Date #3"
                name="beginTollDate3"
                format="d"
              />
              <app-detail-item
                label="New Medical Received"
                name="medicalRecived"
                format="b"
              />
              <app-detail-item
                label="Date Decision Due"
                name="decisionDue"
                format="d"
              />
              <app-detail-item label="Decision" name="decision" />
              <app-detail-item
                label="Extension Letter Sent"
                name="extensionLetterSent"
                format="b"
              />
              <app-detail-item
                label="Date Medical Review Requested"
                name="dateMedicalReviewRequest"
                format="d"
              />
            </app-detail-panel>
          </div>
          <div class="tw-basis-1/3">
            <app-detail-panel [dataSource]="data">
              <app-detail-item
                label="Date Acknowledgement Letter Sent"
                name="dateAcknowledgementLetter"
                format="d"
              />
              <app-detail-item
                label="Date Denial Letter Sent"
                name="dateDenialLetter"
                format="d"
              />
              <app-detail-item label="" name="" />
              <app-detail-item
                label="End Toll Date #1"
                name="endTollDate1"
                format="d"
              />
              <app-detail-item
                label="End Toll Date #2"
                name="endTollDate2"
                format="d"
              />
              <app-detail-item
                label="End Toll Date #3"
                name="endTollDate3"
                format="d"
              />
              <app-detail-item
                label="Attorney Retained"
                name="attorneyRetained"
                format="b"
              />
              <app-detail-item
                label="Date Decision Made"
                name="decisionMade"
                format="d"
              />
              <app-detail-item label="Reason" name="reason" />
              <app-detail-item
                label="Date Extension Letter Sent"
                name="dateExtensionLetterSent"
                format="d"
              />
              <app-detail-item
                label="Date Medical Review Reviewed"
                name="dateMedicalReviewReceived"
                format="d"
              />
            </app-detail-panel>
          </div>
        </div>
      </ng-template>
    </app-table>
  `,
  styles: ``,
})
export class AppealsComponent extends BaseComponent implements OnInit {
  appealsLst: Appeals[] = [];
  async ngOnInit(): Promise<void> {
    this.appealsLst = await this.api.appeals.appeals(getClaimKey());
    this.view.hideLoading();
  }
}
